import React from "react";
import PropTypes from "prop-types";

import Button from "components/Common/Button";
import { NO_OP_FUNCTION } from "services/helpers";

import "./style.scss";

export class InputPassword extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isPasswordShown: false
    };
    this.passwordInput = React.createRef();
  }

  getPlaceholder() {
    const shownPasswordPlaceholder = this.props.placeholder;
    let hiddenPasswordPlaceholder = "";

    if (this.state.isPasswordShown) {
      return shownPasswordPlaceholder;
    }

    shownPasswordPlaceholder.split("").forEach(() => {
      hiddenPasswordPlaceholder += "•";
    });

    return hiddenPasswordPlaceholder;
  }

  /**
    * toggles visibility of password
    */
  changePasswordToggle = () => {
    const { isPasswordShown } = this.state;

    // refocus password input on toggle
    this.passwordInput.current.focus();

    this.setState({
      isPasswordShown: !isPasswordShown
    });
  };

  /**
   * @param {Object} e
   */
  onMouseDown = (e) => {
    e.preventDefault();

    setTimeout(() => {
      this.passwordInput.current.focus();
    }, 0);
  };

  /**
   * @returns {ReactElement}
   */
  render() {
    const {
      autoComplete,
      customClassName,
      inputId,
      invalid,
      onKeyDown,
      onFocus,
      onBlur,
      onPasswordChange,
      toggleDisabled,
      value
    } = this.props;

    const { isPasswordShown } = this.state;

    return (
      <div
        className={`InputPassword ${customClassName}`}
      >
        <div className="InputPassword__input-container">
          <input
            id={inputId}
            className={`
                InputPassword__input-container__input g-input
                ${invalid ? "g-input--invalid" : ""}
            `}
            value={value}
            type={isPasswordShown ? "text" : "password"}
            placeholder={this.getPlaceholder()}
            onChange={e => onPasswordChange(e)}
            onKeyDown={e => (e.key === "Enter" ? onKeyDown() : null)}
            onFocus={onFocus}
            onBlur={onBlur}
            autoComplete={autoComplete}
            ref={this.passwordInput}
            name="password"
          />
          {!toggleDisabled && (
            <Button
              tabIndex={-1}
              onClick={this.changePasswordToggle}
              onMouseDown={this.onMouseDown}
              title="Toggle View Password"
              icon={isPasswordShown ? "View" : "ViewOff"}
              customClassName="InputPassword__input-container__button"
              clear
            />
          )}
        </div>
      </div>
    );
  }
}

InputPassword.propTypes = {
  autoComplete: PropTypes.string,
  customClassName: PropTypes.string,
  inputId: PropTypes.string,
  invalid: PropTypes.bool,
  onPasswordChange: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  onKeyDown: PropTypes.func,
  placeholder: PropTypes.string,
  toggleDisabled: PropTypes.bool,
  value: PropTypes.string
};

InputPassword.defaultProps = {
  autoComplete: "password",
  customClassName: "",
  inputId: undefined,
  invalid: false,
  onPasswordChange: NO_OP_FUNCTION,
  onBlur: NO_OP_FUNCTION,
  onFocus: NO_OP_FUNCTION,
  onKeyDown: NO_OP_FUNCTION,
  placeholder: "Open Sesame ",
  toggleDisabled: false,
  value: ""
};

export default InputPassword;
